export default "__VITE_PUBLIC_ASSET__757a265b__"